// @ts-nocheck
/* eslint-disable */

import * as Types from '../../../graphql/v4/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegionSelectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RegionSelectQuery = { __typename?: 'Query', orderRegions: Array<{ __typename?: 'OrderRegion', id: string, name: string }> };


export const RegionSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RegionSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export function useRegionSelectQuery(baseOptions?: Apollo.QueryHookOptions<RegionSelectQuery, RegionSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionSelectQuery, RegionSelectQueryVariables>(RegionSelectDocument, options);
      }
export function useRegionSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionSelectQuery, RegionSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionSelectQuery, RegionSelectQueryVariables>(RegionSelectDocument, options);
        }
export function useRegionSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionSelectQuery, RegionSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionSelectQuery, RegionSelectQueryVariables>(RegionSelectDocument, options);
        }
export type RegionSelectQueryHookResult = ReturnType<typeof useRegionSelectQuery>;
export type RegionSelectLazyQueryHookResult = ReturnType<typeof useRegionSelectLazyQuery>;
export type RegionSelectSuspenseQueryHookResult = ReturnType<typeof useRegionSelectSuspenseQuery>;